// extracted by mini-css-extract-plugin
export var button = "_n3-2";
export var card = "_n3-0";
export var closeButtonContainer = "_n3-3";
export var iconContainer = "_n3-1";